import { prisma } from "@/lib/db";
import { NextRequest, NextResponse } from "next/server";

export async function GET(request: NextRequest) {
  try {
    const searchParams = request.nextUrl.searchParams;
    const userId = searchParams.get("userId");

    const groups = await prisma.problemGroup.findMany({
      orderBy: { sequence: "asc" },
      include: {
        _count: {
          select: { problems: true },
        },
        ...(userId
          ? {
              userGroupStates: {
                where: { userId },
              },
            }
          : {}),
      },
    });

    const result = groups.map((group) => ({
      id: group.id,
      name: group.name,
      description: group.description,
      sequence: group.sequence,
      problemCount: group._count.problems,
      userState: userId && "userGroupStates" in group && group.userGroupStates?.[0]
        ? {
            status: group.userGroupStates[0].status,
            introducedCount: group.userGroupStates[0].introducedCount,
            stableCount: group.userGroupStates[0].stableCount,
            masteryScore: group.userGroupStates[0].masteryScore,
          }
        : null,
    }));

    return NextResponse.json(result);
  } catch (error) {
    console.error("Error fetching groups:", error);
    return NextResponse.json(
      { error: "Failed to fetch groups" },
      { status: 500 }
    );
  }
}

export async function POST(request: NextRequest) {
  try {
    const body = await request.json();
    const { name, description, sequence } = body;

    if (!name) {
      return NextResponse.json(
        { error: "name is required" },
        { status: 400 }
      );
    }

    // Get next sequence if not provided
    let seq = sequence;
    if (seq === undefined) {
      const lastGroup = await prisma.problemGroup.findFirst({
        orderBy: { sequence: "desc" },
      });
      seq = lastGroup ? lastGroup.sequence + 1 : 0;
    }

    const group = await prisma.problemGroup.create({
      data: {
        name,
        description: description || null,
        sequence: seq,
      },
    });

    return NextResponse.json(group, { status: 201 });
  } catch (error) {
    console.error("Error creating group:", error);
    return NextResponse.json(
      { error: "Failed to create group" },
      { status: 500 }
    );
  }
}
